import './bootstrap';
import 'slick-carousel';


(function($) {
	$(document).ready(function() {   
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });


    if($('.address-dropdown').length > 0){
        $('.address-dropdown').on('click','a.getDirectionClick', function (e) {
          e.preventDefault();
          var lat = $(this).data('lat');
          var lng = $(this).data('lng');

          if(lat && lng){
              $.navigate(lat,lng);
          }

          return false;
        })
    }

    if($('.price-dropdown').length){

        var selectTicketType = document.getElementById('type-selection');

        selectTicketType.addEventListener('click', ({ target }) => { 
          if (target.getAttribute('name') === 'ticket_type') { 
              $(target).closest('.pop-up-steps').find('.step-1').addClass('d-none');
              $(target).closest('.pop-up-steps').find('.step-2').removeClass('d-none');
          }
        });

        
        // $('.price-dropdown').on('click','a.dropdown-item', function (e) {
        //   e.preventDefault();
          
        //   if($(this).hasClass('active')){

        //   }else{
        //     var thisText = $(this).text();
        //     var thisEventId = $(this).data('event');
        //     var thisPriceId = $(this).text();
        //     $(this).closest('.dropdown-menu').find('.active').removeClass('active');
        //     $(this).closest('.dropdown').find('.dropdown-toggle').text(thisText);
        //     if(thisEventId && thisPriceId)
        //       $('#event-buy-'+thisEventId).find('.item-options').val(thisPriceId);
            

        //     $(this).addClass('active');
        //   }

          
        //   return false;
        // })
    }

    // if($('.price-menu').length){
    //     $('.price-menu').on('click','a.price-item', function (e) {
    //       e.preventDefault();
          
    //       if($(this).hasClass('active')){

    //       }else{
    //         var thisText = $(this).text();
    //         var thisEventId = $(this).data('event');
    //         var thisPriceId = $(this).data('price');
    //         $(this).closest('.price-menu').find('.active').removeClass('active');
    //         if(thisEventId && thisPriceId)
    //           $('#event-buy-'+thisEventId).find('.item-options').val(thisPriceId);
            

    //         $(this).addClass('active');
    //       }

          
    //       return false;
    //     })
    // }

    if($('#books-slider').length > 0){
  		$('#books-slider').slick({
            lazyLoad: 'ondemand',
            dots: true,
            autoplay: true,
            autoplaySpeed: 6500,
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            nextArrow: '#book-next',
            prevArrow: '#book-prev',
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
      });
    }

    if($('#testimonial-slider-all').length > 0 && $(window).width() < 767){
      if($('#testimonial-slider-all').hasClass('no-slider')){

      }else{
        $('#testimonial-slider-all').slick({
              lazyLoad: 'ondemand',
              dots: true,
              autoplay: true,
              autoplaySpeed: 6500,
              infinite: true,
              speed: 300,
              slidesToShow: 5,
              slidesToScroll: 1,
              nextArrow: '#testimonial-all-next',
              prevArrow: '#testimonial-all-prev',
              responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
      }
    }

    if($('#testimonial-slider-women').length > 0 && $(window).width() < 767){
      if($('#testimonial-slider-women').hasClass('no-slider')){

      }else{
        $('#testimonial-slider-women').slick({
              lazyLoad: 'ondemand',
              dots: true,
              autoplay: true,
              autoplaySpeed: 6500,
              infinite: true,
              speed: 300,
              slidesToShow: 5,
              slidesToScroll: 1,
              nextArrow: '#testimonial-women-next',
              prevArrow: '#testimonial-women-prev',
              responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
      }
    }

    if($('#testimonial-slider-single').length > 0 && $(window).width() < 767){
      if($('#testimonial-slider-single').hasClass('no-slider')){

      }else{
        $('#testimonial-slider-single').slick({
              lazyLoad: 'ondemand',
              dots: true,
              autoplay: true,
              autoplaySpeed: 6500,
              infinite: true,
              speed: 300,
              slidesToShow: 5,
              slidesToScroll: 1,
              nextArrow: '#testimonial-single-next',
              prevArrow: '#testimonial-single-prev',
              responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
      }
    }


    if($('#testimonial-slider-couple').length > 0  && $(window).width() < 767){
      if($('#testimonial-slider-couple').hasClass('no-slider')){

      }else{
        $('#testimonial-slider-couple').slick({
              lazyLoad: 'ondemand',
              dots: true,
              autoplay: true,
              autoplaySpeed: 6500,
              infinite: true,
              speed: 300,
              slidesToShow: 5,
              slidesToScroll: 1,
              nextArrow: '#testimonial-couple-next',
              prevArrow: '#testimonial-couple-prev',
              responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
      }
    }


    if($('#testimonial-slider-body-painting').length > 0 && $(window).width() < 767){
      $('#testimonial-slider-body-painting').slick({
            lazyLoad: 'ondemand',
            dots: true,
            autoplay: true,
            autoplaySpeed: 6500,
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            nextArrow: '#testimonial-body-painting-next',
            prevArrow: '#testimonial-body-painting-prev',
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
      });
    }

    if($('#testimonial-slider-event').length > 0 && $(window).width() < 767){
      if($('#testimonial-slider-event').hasClass('no-slider')){

      }else{
        $('#testimonial-slider-event').slick({
              lazyLoad: 'ondemand',
              dots: true,
              autoplay: true,
              autoplaySpeed: 6500,
              infinite: true,
              speed: 300,
              slidesToShow: 5,
              slidesToScroll: 1,
              nextArrow: '#testimonial-event-next',
              prevArrow: '#testimonial-event-prev',
              responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
      }
    }


	});
})(jQuery);




$.navigate =  function (lat, lng) {

    if ((navigator.platform.indexOf("iPhone") !== -1) || (navigator.platform.indexOf("iPod") !== -1)) {
      function iOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
          // supports iOS 2.0 and later
          var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
          return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
        }
      }
      var ver = iOSversion() || [0];

      var protocol = 'http://';
      if (ver[0] >= 6) {
        protocol = 'maps://';
      }
      window.location = protocol + 'maps.apple.com/maps?daddr=' + lat + ',' + lng + '&amp;ll=';
    }
    else {
      window.open('http://maps.google.com?daddr=' + lat + ',' + lng + '&amp;ll=');
    }
}


$.append_notification = function(status,text_content){
   
    var randomString = 'notification_'+Math.random().toString(36).substring(7);
    var notification_html = '<div class="mb-2 toast align-items-center '+status+' '+randomString+'" role="alert" aria-live="assertive" aria-atomic="true">'+
                                '<div class="d-flex">'+
                                '<div class="toast-body">'+text_content+'</div>'+
                                '<button type="button" class="btn-close me-2 m-auto btn-close-white" data-bs-dismiss="toast" aria-label="Close"></button>'+
                                '</div>'+
                            '</div>';

    $('#notification_content').prepend(notification_html).promise().done(function(){ 
        var myAlert = $('#notification_content').find('.'+randomString);
        $(myAlert).toast('show');

        myAlert[0].addEventListener('hidden.bs.toast', function () {
          // $(myAlert).remove();
        })
    }); 

}

$.hide_notification = function(){
    var myAlert = $('#notification_content').find('.toast');
    $(myAlert).toast('hide');
}
